import React, { useState, useEffect, useRef } from 'react';
import {
  Typography,
  TextField,
  Button,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  FormGroup,
  FormControlLabel,
  Checkbox, 
  Pagination,
  Autocomplete
} from '@mui/material';
import { Edit, Delete } from '@mui/icons-material';
import ConversationDialog from './Dialog';
import { useNavigate } from 'react-router-dom'; 
import CustomerLayout from './CustomerLayout';
import WithAuth from './WithAuth';


  function RecentContacts({merge = false, onDelete = true}) {
    const navigate = useNavigate();
      const [data, setData] = useState([]);
      const [filteredData, setFilteredData] = useState([]);
      // const [merge, setMerge] = useState(false)
      const [checkedRows, setCheckedRows] = useState([]); // Tracks checked rows
      const [filters, setFilters] = useState({
        uniqueMergeId :'',
        contactId: '',
        name: '',
        Role: '',
        stDepartment: '',
        internalOrExternal: '',
        school: '',
        city: '',
        state: '',
        country: '',
        location: '',
        ContactNumbers: '',
        emailIds: '',
        programsAttended: '',
        links: '',
      });
      const [selectedConversations, setSelectedConversations] = useState([]);
      const [openDialog, setOpenDialog] = useState(false);
      const [isAddingConversation, setIsAddingConversation] = useState([false, undefined]); // To toggle between add and view mode
      const [newConversation, setNewConversation] = useState({
        _id: '',
        title: '',
        conversationText: '',
        STResource: '', // add your third value here
      });
    
      const [currentPage, setCurrentPage] = useState(1);
      const rowsPerPage = 8; 
    
      const [selectAll, setSelectAll] = useState(false);
      
        const handlePageChange = (event, page) => {
          setCurrentPage(page);
        };
      
        const paginatedRows = filteredData.slice(
          (currentPage - 1) * rowsPerPage,
          currentPage * rowsPerPage
        );
      
        const handleCheckboxChange = (rowId) => {
          setCheckedRows((prev) =>
            prev.includes(rowId)
              ? prev.filter((id) => id !== rowId) // Remove if already checked
              : [...prev, rowId] // Add if not already checked
          );
        };
      
        const fetchContacts = async () => {
          try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/customers/recents`, {
              method: 'GET',
            });
      
            if (!response.ok) {
              throw new Error('Error fetching data');
            }
      
            let data = await response.json();
            console.log('recent data: '+data)
            // data = data.filter(item => item.trash === true);
            setData(data);
            setFilteredData(data);
          } catch (error) {
            console.error('Error fetching data:', error);
          }
        };
      
        const fetchConversations = async (_id) => {
          console.log('fetching conversations of customer with id: '+_id)
          try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/conversations/${_id}`, {
              method: 'GET',
            });
      
            if (!response.ok) {
              throw new Error('Error fetching conversations');
            }
      
            const conversations = await response.json();
            setSelectedConversations(conversations);
            setIsAddingConversation((prev) => [false, prev[1]]); // Set to view mode
            setOpenDialog(true);
          } catch (error) {
            console.error('Error fetching conversations:', error);
          }
        };
      
        const handleFilterChange = (field, value) => {
          const updatedFilters = { ...filters, [field]: value };
          setFilters(updatedFilters);
      
          // Apply filtering logic
          const filtered = data.filter((row) => {
            return Object.keys(updatedFilters).every((key) => {
              const filterValue = updatedFilters[key];
              if (!filterValue) return true;
              const rowValue = Array.isArray(row[key])
                ? row[key].join(', ').toLowerCase()
                : row[key]?.toString().toLowerCase() || '';
              return rowValue.includes(filterValue.toLowerCase());
            });
          });
      
          setFilteredData(filtered);
        };
      
        // Extract unique options for each field
        const getUniqueOptions = (key) => {
          const options = data.map((row) => row[key]).flat();
          return [...new Set(options.filter(Boolean))];
        };
      
        const handleAddConversation = async (_id) => {
          console.log('======='+_id)
          setNewConversation((prev) => ({
            ...prev,
            _id: isAddingConversation[1]
          }));
          console.log('_id: '+isAddingConversation[1])
          
          try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/conversations/add`, {
              method: 'POST',
              body: JSON.stringify(newConversation),
              headers: { 'Content-Type': 'application/json' },
            });
      
            if (!response.ok) {
              throw new Error('Error adding conversation');
            }
      
            alert('Conversation added successfully');
            setNewConversation((prev) => ({
              _id: isAddingConversation[1],
              title: '',
              conversationText: '',
              STResource: '',
            }));
            // fetchConversations(newConversation.contactId); // Optionally fetch updated conversations after adding
          } catch (error) {
            console.error('Error adding conversation:', error);
          }
        };
      
        const handleDeleteConversation = async (id, customerId) => {
          try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/conversations/${id}`, {
              method: 'DELETE',
            });
      
            if (!response.ok) {
              throw new Error('Error deleting conversation');
            }
      
            // alert('Conversation deleted successfully');
            fetchConversations(customerId);
            // simulateClick(); 
          } catch (error) {
            console.error('Error deleting conversation:', error);
          }
        };
      
        useEffect(() => {
          fetchContacts(); // Fallback to fetching all contacts if mergedContacts is empty
        }, []);
            
        const handleSelectAll = () => {
          const allIds = paginatedRows.map((row) => row.uniqueMergeId);
          setCheckedRows((prevSelected) =>
            prevSelected.length === paginatedRows.length ? [] : allIds
          );
        };
      
        const handleDeselectAll = () => {
          setCheckedRows([]);
        }
      
    const isSelected = (id) => checkedRows.includes(id);
  
    // useEffect(() => {
    //   const fetchRecentContacts = async () => {
    //     try {
    //       const response = await fetch(process.env.REACT_APP_API_URL+"/api/customers/recents");
    //       if (!response.ok) {
    //         throw new Error("Failed to fetch recent contacts");
    //       }
    //       const data = await response.json();
    //       console.log('recents data from server: '+data)
    //       setContacts(data);
    //     } catch (error) {
    //       alert('Error fetching recent contacts')
    //       console.error("Error fetching recent contacts:", error);
    //     } finally {
    //       setLoading(false);
    //     }
    //   };
  
    //   fetchRecentContacts();
    // }, []);
  
    return (
      <CustomerLayout>
      <div style={{ padding: '20px' }}>
  
        <Typography color='primary' variant="h6" style={{ marginTop: '60px', marginLeft: '20px', marginBottom: '10px', fontWeight: 'bold' }}>
          {'Recent Contacts'}
        </Typography>
  
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', marginBottom: '20px' }}>
          {Object.keys(filters).map((key) => (
            <Autocomplete
            key={key}
            options={getUniqueOptions(key)}
            getOptionLabel={(option) => option.toString()}
            value={filters[key] || ''}
            onChange={(e, value) => handleFilterChange(key, value || '')}
            renderInput={(params) => (
              <TextField
                {...params}
                label={key.replace(/([A-Z])/g, ' $1').replace(/^./, (str) => str.toUpperCase())}
                variant="outlined"
                fullWidth
                style={{ flex: '1 1 calc(33.33% - 10px)', minWidth: '200px' }}
              />
            )}
          />
          ))}
        </div>
        <>
        {/* {checkedRows.length != 0  && onDelete && <Button onClick={handleCheckedDelete}>{!paginatedRows.length == 0 ? 'Delete from Trash':''}</Button>} */}
        {/* {checkedRows.length != 0 && <Button onClick={handleRestore}>{!paginatedRows.length == 0 ? 'Restore': ''}</Button>} */}
        {/* {(merge || onDelete) && <Button onClick={selectAll ? handleDeselectAll : handleSelectAll}>{paginatedRows.length == 0 ? '' : checkedRows.length === paginatedRows.length ? 'Deselect All' : 'Select All'}</Button>} */}
        </>
  
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                {/* {(merge || onDelete) && <TableCell></TableCell>} */}
                <TableCell>Contact ID</TableCell>
                <TableCell>Name</TableCell>
                <TableCell>Role</TableCell>
                <TableCell>stDepartment</TableCell>
                <TableCell>Internal/External</TableCell>
                <TableCell>School</TableCell>
                <TableCell>City</TableCell>
                <TableCell>State</TableCell>
                <TableCell>Country</TableCell>
                <TableCell>School Location</TableCell>
                <TableCell>Contact Numbers</TableCell>
                <TableCell>Email IDs</TableCell>
                <TableCell>Programs Attended</TableCell>
                <TableCell>Links</TableCell>
                <TableCell>Conversations</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedRows.map((row, index) => (
                <TableRow key={index}>
                  {/* {(merge || onDelete) && <TableCell>
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={isSelected(row.uniqueMergeId) || checkedRows.includes(row.uniqueMergeId)} // Check if row is selected
                          onChange={() => handleCheckboxChange(row.uniqueMergeId)} // Handle toggle
                          color="primary"
                        />
                      }
                      label=""
                    />
                  </FormGroup>
                  </TableCell>} */}
                  <TableCell style={{ cursor: 'pointer' }} onClick={() => {
                  }}>{row.uniqueMergeId}</TableCell>
                  <TableCell>{row.name}</TableCell>
                  <TableCell>{row.Role}</TableCell>
                  <TableCell>{row.stDepartment}</TableCell>
                  <TableCell>{row.internalOrExternal}</TableCell>
                  <TableCell>{row.school}</TableCell>
                  <TableCell>{row.city}</TableCell>
                  <TableCell>{row.state}</TableCell>
                  <TableCell>{row.country}</TableCell>
                  <TableCell>{row.location}</TableCell>
                  <TableCell>{row.ContactNumbers.join(', ')}</TableCell>
                  <TableCell>{row.emailIds.join(', ')}</TableCell>
                  <TableCell>{row.programsAttended.join(', ')}</TableCell>
                  <TableCell>{row.links.join(', ')}</TableCell>
                  <TableCell>
                    <Button onClick={() => {
                      setIsAddingConversation([false, row._id]);
                      fetchConversations(row._id)
                    }}>
                      Show Conversations
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'center' }}>
            <Pagination
              count={Math.ceil(filteredData.length / rowsPerPage)}
              page={currentPage}
              onChange={handlePageChange}
              color="primary"
            />
        </div>
        {/* <button onClick={() => setOpenDialog(true)}>Open Dialog</button> */}
        <ConversationDialog
          open={openDialog}
          onClose={() => setOpenDialog(false)}
          isAddingConversation={isAddingConversation}
          newConversation={newConversation}
          setNewConversation={setNewConversation}
          selectedConversations={selectedConversations}
          handleAddConversation={handleAddConversation}
          handleDeleteConversation={handleDeleteConversation}
        />
        
      </div>
      </CustomerLayout>
    );
  }

export default WithAuth(RecentContacts);
